import React from 'react'
import { Outlet } from 'react-router-dom'
import { useRemoteTheme } from './hooks/useRemoteTheme'

export const ThemeOutlet = () => {
  useRemoteTheme()

  return <Outlet />
}
